import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Aircrafts, Software } from '../../models/equipment.model';
import { EquipmentState, LoadingState } from '../store.states';
import * as EquipmentAction from './equipment.actions';

export const aircraftsAdapter = createEntityAdapter<Aircrafts>({
  selectId: (aircraft) => aircraft.serialNumber ?? aircraft.unitNumber,
  sortComparer: false,
});

export const softwareAdapter = createEntityAdapter<Software>({
  selectId: (software) => software.downloadLink,
  sortComparer: false,
});

export const initialState: EquipmentState = {
  aircrafts: aircraftsAdapter.getInitialState(),
  software: softwareAdapter.getInitialState(),
  loadingState: LoadingState.FUTURE,
  updateState: LoadingState.FUTURE,
  error: null,
  completed: false,
};

export const equipmentReducer = createReducer(
  initialState,
  on(EquipmentAction.loadingEquipment, (state) => ({
    ...state,
    loadingState: LoadingState.PENDING,
    completed: false,
  })),

  on(
    EquipmentAction.loadingEquipmentSuccess,
    (state: EquipmentState, { equipment }) => {
      const nextState: EquipmentState = {
        ...state,
        loadingState: LoadingState.SUCCESS,
        completed: !!(
          equipment.aircrafts?.length && equipment.aircrafts.at(0)?.name
        ),
      };

      if (equipment.aircrafts) {
        nextState.aircrafts = aircraftsAdapter.setAll(
          equipment.aircrafts,
          state.aircrafts,
        );
      }

      if (equipment.software) {
        nextState.software = softwareAdapter.setAll(
          equipment.software,
          state.software,
        );
      }

      return nextState;
    },
  ),

  on(EquipmentAction.loadingEquipmentError, (state, { error }) => ({
    ...state,
    loadingState: LoadingState.ERROR,
    error: error,
    completed: false,
  })),

  on(EquipmentAction.activatingAircraft, (state) => ({
    ...state,
    updateState: LoadingState.PENDING,
  })),

  on(EquipmentAction.activatingAircraftSuccess, (state) => ({
    ...state,
    updateState: LoadingState.SUCCESS,
  })),

  on(EquipmentAction.activatingAircraftError, (state, { error }) => ({
    ...state,
    updateState: LoadingState.ERROR,
    error: error,
  })),
);
